import Model from '@/lib/data/Model';

class BuildingRSA extends Model {
    static idProperty = 'id';

    fields = [
        'type',
        'name',
        {
            name: 'building_value_percentage',
            type: 'float',
        },
        {
            name: 'building_value',
            type: 'float',
        },
        {
            name: 'plant_value_percentage',
            type: 'float',
        },
        {
            name: 'plant_value',
            type: 'float',
        },
        {
            name: 'stock_value_percentage',
            type: 'float',
        },
        {
            name: 'stock_value',
            type: 'float',
        },
        {
            name: 'other_value_percentage',
            type: 'float',
        },
        {
            name: 'other_value',
            type: 'float',
        },
        {
            name: 'bi_value_percentage',
            type: 'float',
        },
        {
            name: 'bi_value',
            type: 'float',
        },
        'occ',
        'yr',
        'rc',
        'wc',
        'cp',
        'ocs',
        'sa',
        'sd',
        'st',
        'eh',
        'gf',
        'ta',
        {
            name: 'ohz',
            defaultValue: [],
        },
    ];

    /**
     * Create the User object
     *
     * @param {Object} data - Seed data for this object.
     */

    calc = (value, percentage) => parseFloat(((value * percentage) / 100).toFixed(2));

    get buildingValueTotal() {
        return this.calc(this.building_value, this.building_value_percentage);
    }

    get plantValueTotal() {
        return this.calc(this.plant_value, this.plant_value_percentage);
    }

    get stockValueTotal() {
        return this.calc(this.stock_value, this.stock_value_percentage);
    }

    get otherValueTotal() {
        return this.calc(this.other_value, this.other_value_percentage);
    }

    get biValueTotal() {
        return this.calc(this.bi_value, this.bi_value_percentage);
    }

    get total() {
        return parseFloat(
            (
                this.buildingValueTotal +
                this.plantValueTotal +
                this.stockValueTotal +
                this.otherValueTotal +
                this.biValueTotal
            ).toFixed(2)
        );
    }

    constructor(data) {
        super(data);
        this.init();
    }
}

export default BuildingRSA;
